// extracted by mini-css-extract-plugin
export default {"root":"search_root__nIzuY","input":"search_input__njbvf","search":"search_search__8wD1Y","close":"search_close__2uUjC"};